import OrderAction from './orderAction';

export default class SendApprovedTicketsToBuyerAction extends OrderAction {
    static NAME = 'send_tickets_approval_buyer';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    static condition(order) {
        return !order.removed && ['valid', 'reservation'].includes(order.status);
    }

    static is_available({ feature_flags, event }) {
        return event.is_moderation_enabled && !['over', 'closed'].includes(event.status) && feature_flags.includes('EO_SMB');
    }
    get needs_selection() {
        return false;
    }
    get needs_confirm() {
        return true;
    }
    get withToastRun() {
        return true;
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
